import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  getCompareList,
  removeFromCompare,
  clearCompare,
  MAX_COMPARE,
  COMPARE_EVENT,
} from '../../../services/compareStorage.js';

// Sticky bottom bar - only renders when at least one product is selected
// for compare. Lives at the layout level via PublicLayout.
export default function CompareBar() {
  const [list, setList] = useState(() => getCompareList());

  useEffect(() => {
    const refresh = () => setList(getCompareList());
    window.addEventListener(COMPARE_EVENT, refresh);
    // Other tab edits.
    const onStorage = (e) => {
      if (e.key === 'itec_compare') refresh();
    };
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(COMPARE_EVENT, refresh);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  if (!list.length) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t bg-white/95 shadow-[0_-4px_12px_rgba(0,0,0,0.06)] backdrop-blur">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-3 px-3 py-2 sm:px-4">
        <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">
          Compare ({list.length}/{MAX_COMPARE})
        </span>
        <div className="flex flex-1 flex-wrap items-center gap-2">
          {list.map((p) => (
            <div
              key={p.id}
              className="flex items-center gap-2 rounded-full border bg-white px-2 py-1 text-xs"
            >
              {p.mainImage ? (
                <img
                  src={p.mainImage}
                  alt={p.name}
                  className="h-6 w-6 rounded object-cover"
                />
              ) : (
                <div className="h-6 w-6 rounded bg-slate-100" />
              )}
              <Link
                to={`/product/${p.slug}`}
                className="max-w-[10rem] truncate hover:text-brand-600"
              >
                {p.name}
              </Link>
              <button
                type="button"
                onClick={() => removeFromCompare(p.id)}
                aria-label={`Remove ${p.name} from compare`}
                className="text-slate-400 hover:text-red-500"
              >
                ✕
              </button>
            </div>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => clearCompare()}
            className="text-xs text-slate-500 underline hover:text-red-500"
          >
            Clear
          </button>
          <Link
            to="/compare"
            className="rounded-md bg-brand-500 px-3 py-1.5 text-xs font-medium text-white hover:bg-brand-600"
          >
            Compare now
          </Link>
        </div>
      </div>
    </div>
  );
}
